// Makes the first letter uppercase, l(lower) is optional to turn anything
// but the firs letter to lower letters
function upperFirstLetter(s, l) {
  if (!s || typeof s !== 'string') return s
  if (l) return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
  return s.charAt(0).toUpperCase() + s.slice(1)
}

// Remove \n \r \? from string in order to make them legible
function clearEscapedCharacters(v) {
  if (!v) return ''
  return v.replace(/(\\n|\\t|\\s\\s)+/g, '').replace(/(\\")+/g, '"')
}

function truncate(str = '', limit = 999) {
  if (str.length && str.length > limit) return `${str.slice(0, limit)}...`
  return str
}

function camelCase(string) {
  if (typeof string !== 'string' || !string?.length) {
    return string
  }

  const words = string.split(/[^a-z]/i)
  const formattedString = words.reduce((acc, cur, index) => {
    if (index === 0) {
      return `${acc}${cur.toLowerCase()}`
    }

    return `${acc}${upperFirstLetter(cur, true)}`
  }, '')

  return formattedString
}

function spliceWithEmoji(string, limit) {
  const stringAsSafeArray = [...new Intl.Segmenter().segment(string)].map(x => x.segment)
  const splitArray = stringAsSafeArray.splice(0, limit)
  const arrayAsString = splitArray.join('')
  return arrayAsString
}

export default {
  upperFirstLetter,
  clearEscapedCharacters,
  truncate,
  camelCase,
  spliceWithEmoji,
}
